import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getBrandsByEmpresa, getCommercialNameList, getEmpresas, getEmpresasByCategoria, getBannersByEmpresaId } from "../api";


export const useListaEmpresasMutation = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['listaEmpresasMutate'],
    mutationFn: getEmpresas,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['empresas'],
        status,
        {
          updatedAt: new Date().getTime() + 1000
        }
      );
    },
  });

  return query;
};

export const HookListaEmpresas = () => {
  // useQuery es la herramienta correcta para operaciones GET (obtener datos).
  const query = useQuery({
    // La queryKey es estática si la lista de empresas no depende de parámetros
    queryKey: ['listaEmpresas'], 
    
    // Asume que getEmpresas es tu función API que llama al endpoint.
    queryFn: getEmpresas, 
    
    // Tiempo de frescura: 10 minutos (para evitar refetch en cada focus)
    staleTime: 1000 * 60 * 10, 
    
    // Si quieres que solo devuelva data.data (asumiendo que tu API devuelve {status, data})
    select: (data) => data.data // Esto facilita el acceso a la lista real
});

return query;
};

export const useListaEmpresas = () => {
  const query = useQuery({
    queryKey: ['listaEmpresas'],
    queryFn: getEmpresas,
    staleTime: 1000 * 60 * 10,
    select: (data) => data,
  });
  return query;
};

export const useListaEmpresaByCategoria = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['listaEmpresasMutate'],
    mutationFn: getEmpresasByCategoria,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['empresas'],
        status,
        {
          updatedAt: new Date().getTime() + 100
        }
      );
    },
  });

  return query;
}

export const BrandListByEmpresas = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['listaEmpresasMutate'],
    mutationFn: getBrandsByEmpresa,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['listaMarcasEmpresa'],
        status,
        {
          updatedAt: new Date().getTime() + 100000
        }
      );
      return status;
    },
  });

  return query;
}

export const useListaEmpresasPortal = () => {
  const query = useQuery(
    ['listaEmpresasPortal'],
    () => getCommercialNameList(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );

  return query;
}

export const BannersByEmpresa = ( idEmpresa = 0 ) => {
  const query = useQuery(
    ['bannersByEmpresa', idEmpresa],
    () => getBannersByEmpresaId(idEmpresa),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}